import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { KitchenPage } from '../../../kitchen/kitchen';
import { TpvLoaderPage } from '../../../tpv/tpv-loader/tpv-loader';
import { HomePage } from '../../../home/home';
import { OrdersLoaderPage } from '../../../orders/orders-loader/orders-loader';



@Component({
  selector: 'page-popup-new-apps',
  templateUrl: 'popup-new-apps.html',
})
export class PopupNewAppsPage {

  app: string = 'all';

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public toastCtrl: ToastController) {
    this.app = this.navParams.get('app');
  }

  close() {
    if (this.globals.restaurant.access_pos) {
      switch (this.app) {
        case 'all':
          this.navCtrl.setRoot(HomePage);
          break;
        case 'print':
          this.navCtrl.setRoot(HomePage);
          break;
        case 'kds':
          this.openKds();
          break;
        case 'order':
          this.openOrder();
          break;
        case 'pos':
          this.openPos();
          break;
        default:
          this.navCtrl.setRoot(HomePage);
          break;
      }
    } else {
      this.navCtrl.setRoot(HomePage);
    }
  }

  openPlayStore() {
    switch (this.app) {
      case 'all':
        this.openLink('https://play.google.com/store/apps/developer?id=MyChefTool');
        break;
      case 'print':
        this.openLink('https://play.google.com/store/apps/details?id=com.mycheftool.printer');
        break;
      case 'kds':
        this.openLink('https://play.google.com/store/apps/details?id=com.mycheftool.kds');
        break;
      case 'order':
        this.openLink('https://play.google.com/store/apps/details?id=com.mycheftool.orders');
        break;
      case 'pos':
        this.openLink('https://play.google.com/store/apps/details?id=com.mycheftool.tpv');
        break;
      default:
        this.openLink('https://play.google.com/store/apps/developer?id=MyChefTool');
        break;
    }
  }

  openAppStore() {
    switch (this.app) {
      case 'all':
        this.openLink('https://apps.apple.com/es/developer/software-girona-sociedad-limitada/id918489945');
        break;
      case 'print':
        this.openLink('https://apps.apple.com/es/app/mct-print/id1624692351');
        break;
      case 'kds':
        this.openLink('https://apps.apple.com/es/app/mct-kitchen-display-system/id1625644596');
        break;
      case 'order':
        this.openLink('https://apps.apple.com/es/app/mct-order/id1626244345');
        break;
      case 'pos':
        this.openLink('https://apps.apple.com/es/app/mct-pos/id1628506564');
        break;
      default:
        this.openLink('https://apps.apple.com/es/developer/software-girona-sociedad-limitada/id918489945');
        break;
    }
  }

  openKds() {
    this.globals.side_menu_active = 'kitchen';
    this.navCtrl.push(KitchenPage);
  }

  openOrder() {
    this.globals.side_menu_active = 'order';
    this.navCtrl.setRoot(OrdersLoaderPage);
  }

  openPos() {
    if (this.globals.platform_mobile) {
      this.navCtrl.setRoot(OrdersLoaderPage);
    } else {
      this.globals.side_menu_active = 'tpv';
      this.navCtrl.setRoot(TpvLoaderPage);
    }
  }

  openLink(url) {
    if (this.globals.so_mobile) {
      window.location.assign(url);
    } else {
      window.open(url, '_blank');
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/popups/popup-new-apps/popup-new-apps.ts